import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import _toUpper from 'lodash/toUpper';
import _isNil from 'lodash/isNil';
// Serialization
import { serialize, deserialize } from 'serializr';
import { workSpaceGroupSchema } from './schemas';
// Fragments
import { workspaceGroupFragment } from './fragments';
// Custom
import { SEARCHFIELD_TYPES } from '../../constants/App';
import { findInList } from '../../utils/Tools';

/**
 * Serialization
 */
const deserializeWorkspaceGroup = (data) => deserialize(workSpaceGroupSchema, data);
const serializeWorkspaceGroup = ({
  addedCarparkIds, deletedCarparkIds, id, name, workspaceId,
}) => ({
  ...serialize(workSpaceGroupSchema, {
    ...(!_isNil(addedCarparkIds) && { addedCarparkIds }),
    ...(!_isNil(deletedCarparkIds) && { deletedCarparkIds }),
    id,
    name,
    workspaceId,
  }),
});

const typeList = [
  {
    key: 'carpark_default',
    value: 'carpark_default',
  },
  {
    key: 'regular',
    value: 'regular',
  },
];

/**
 * Utils
 */
const workspaceGroupType = (workspaceGroup) => findInList(typeList, 'value', workspaceGroup, 'type');
const isRegular = (workspaceGroup) => _get(workspaceGroupType(workspaceGroup), 'value') === typeList[1].value;

/**
 * GraphQL
 */
const queListWorkspaceGroups = `
  query ListWorkspaceGroups($input: ListWorkspaceGroupsInput!, $pagination: PaginationInput, $search: ListWorkspaceGroupsSearchInput, $sort: [ListWorkspaceGroupsSortInput!]) {
    listWorkspaceGroups(input: $input, pagination: $pagination, search: $search, sort: $sort) {
      entries {
        ...workspaceGroupFragment
      },
      pageNumber,
      pageSize,
      totalEntries,
      totalPages
    }
  }

  ${workspaceGroupFragment}
`;

const queGetWorkspaceGroup = `
  query GetWorkspaceGroup($input: GetWorkspaceGroupInput!) {
    getWorkspaceGroup(input: $input) {
      ...workspaceGroupFragment
    }
  }

  ${workspaceGroupFragment}
`;

const mutCreateWorkspaceGroup = `
  mutation CreateWorkspaceGroup($input: CreateWorkspaceGroupInput!) {
    createWorkspaceGroup(input: $input) {
      ...workspaceGroupFragment
    }
  }

  ${workspaceGroupFragment}
`;

const mutUpdateWorkspaceGroup = `
  mutation UpdateWorkspaceGroup($input: UpdateWorkspaceGroupInput!) {
    updateWorkspaceGroup(input: $input) {
      id
    }
  }
`;

/**
 * Model
 */
const workspaceGroup = {
  name: 'workspaceGroup',
  icon: 'workspace',

  // Serialization
  deserialize: deserializeWorkspaceGroup,
  serialize: serializeWorkspaceGroup,

  // Utils
  isRegular,

  // List features
  listFeatures: {
    // Default list params
    defaultParams: {
      pagination: {
        page: 1,
        pageSize: 20,
      },
      sort: [{ field: 'name', dir: 'asc' }],
    },

    // Columns
    columnsQuantity: () => ({
      xs: 1,
      sm: 1,
      md: 1,
      lg: 1,
      xl: 1,
    }),
    columns: [
      {
        key: 'name',
        labelId: 'field.name',
        field: 'name',
        sortable: true,
      },
    ],

    // Search fields
    searchFields: [
      {
        key: 'name',
        labelId: 'field.name',
        field: 'name',
        initial: '',
        isUndefined: (value) => _isEmpty(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.string,
        filter: {
          field: 'name',
        },
      },
      {
        key: 'carparkId',
        labelId: '',
        field: 'carparkId',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        excludeFilterFields: ['carparkId'],
        hidden: true,
        type: SEARCHFIELD_TYPES.resource,
        filter: {
          field: 'carparkId',
        },
      },
      {
        key: 'workspaceGroupId',
        labelId: '',
        field: 'workspaceGroupId',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        hidden: true,
        excludeFilterFields: ['workspaceGroupId'],
        type: SEARCHFIELD_TYPES.resource,
        filter: {
          field: 'workspaceGroupId',
        },
      },
    ],

    ONLY_REGULAR_FILTER: {
      field: 'type',
      operator: SEARCHFIELD_TYPES.enum.defaultOperator(),
      value: _toUpper(typeList[1].value),
    },
  },

  // GraphQL
  queListWorkspaceGroups,
  queGetWorkspaceGroup,
  mutCreateWorkspaceGroup,
  mutUpdateWorkspaceGroup,
};

module.exports = workspaceGroup;



// WEBPACK FOOTER //
// ./models/cpm/workspaceGroup.js